import React from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

function Header({ project, company }) {
  return (
    <div className="bannerContainer">
      <div className="contentWrapper">
        <h1 className="projectName">{project?.project_name}</h1>
        <p className="projectDescription">{project?.description}</p>
        <div className="projectDetails">
          <div className="owner">
            <h3>Owner</h3>
            <Link to={`/company/${project?.company_id}`} className="companyLink">
              {company?.company_name}
            </Link>
          </div>
          <div className="location">
            <h3>Location</h3>
            <span>{project?.location}</span>
          </div>
          <div className="stage">
            <h3>Stage</h3>
            <span>{project?.stage}</span>
          </div>
          <div className="commodities">
            <h3>Commodities</h3>
            <ul>
              {project?.commodity.split(',').map((commodity, index, array) => (
                <React.Fragment key={index}>
                  <li>{commodity.trim()}</li>
                  {index < array.length - 1 && <li className="separator">|</li>}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header 